module.exports = __webpack_public_path__ + "img/icon-rent-office.1f89bbe5.svg";